import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import engine from '../Support/Engine';

import Processing from '../UI/Processing';

class SearchForm extends Component {

	state = {
		search: '',
		processing: false,
		result: 0,
		message: '',
		redirectTo: ''
	}


	steFieldChanged = (event) => {
		this.setState({search: event.target.value});
	}


	steKeyboardAction = (event) => {
		if(event.key === 'Enter')
			this.findMatter();
	}



	findMatter = () => {

		// Clean matter ID
		const matter_id = this.state.search.toLowerCase().replace(/[^a-z0-9]*/gi, '');

		this.setState({
			search: matter_id,
			processing: true,
			result: 0,
			message: ''
		});

		const id_format = /^[a-z]{4}[0-9]{4}$/;
		if(!id_format.test(matter_id)) {
			this.setState({
				processing: false,
				result: -1,
				message: 'Please enter a valid matter ID (format: aaaa0000)'
			});
			return;
		}

		engine.post('/matter/search/', {code: matter_id, tk: this.props.token})
			.then(packet => {
				if(packet.data.result) {
					this.setState({
						processing: false,
						result: 1,
						message: 'Matter found, redirecting...'
					});
					setTimeout(() => {
						this.setState({redirectTo: '/matter/' + this.state.search});
					}, 1500);
				}
				else {
					this.setState({
						processing: false,
						result: -1,
						message: 'No matter found, try a different ID'
					});
				}
			})
			.catch(error => {
				console.log(error);
				this.setState({
					processing: false,
					result: -1,
					message: 'Sorry, there was a problem with the search'
				});
			});

	}



	render() {

		if(this.state.redirectTo !== '') {
			return <Redirect to={this.state.redirectTo} />;
		}

		let search_btn = <button className='btn search-form__btn' onClick={this.findMatter}>Find</button>;
		if(this.state.processing) search_btn = <div className='search-form__loading'><Processing colour='white' />&nbsp;</div>;

		let message_class = 'search-form__response__line';
		if(this.state.result < 0) message_class += ' search-form__response__line--problem';
		if(this.state.result > 0) message_class += ' search-form__response__line--success';

		return (
			<div className='search-form'>

				<div className='search-form__control'><input
					className='search-form__input' type='text' name='search' placeholder='Matter ID'
					value={this.state.search} onChange={this.steFieldChanged} onKeyPress={this.steKeyboardAction} />{search_btn}</div>

				<div className='search-form__response'>
					<p className={message_class}>{this.state.message}</p>
				</div>

			</div>
		);

	}

}


export default SearchForm;


// WEBPACK FOOTER //
// ./src/Blocks/SearchForm.js